//Librairies
import React, {useEffect, useRef} from 'react';
import styled from "styled-components";
import {gsap} from 'gsap';

//Icons
import {RiLinkedinLine} from 'react-icons/ri';
import {FiGithub} from 'react-icons/fi';
//Styles
import {LineMailHome} from '../styles/globalStyles';


const Social = ({timeline}) => {




    useEffect(() => {
        timeline.from((".social1"),{
            duration:.8,
            y:400
        })

    },[])

    return (
        <>
        <SocialReseaux className="social1">
            <ul className="contains-social" >
                <li>
                    <a target="_blank" href="https://www.linkedin.com/in/vasco-barreiros/" >
                        <RiLinkedinLine size={30}/>
                    </a>
                </li>
                <li>
                    <a target="_blank" href="https://github.com/vascob-77" >
                        <FiGithub size={30}/>
                    </a>
                </li>
            </ul>
        </SocialReseaux>

        <LineMailHome className="social1 mail">
            <p>vascbarreiros@gmail.com</p>
        </LineMailHome>
        </>
    );
};


const SocialReseaux = styled.div`
  position: fixed;
  bottom: 0;
  left: 40px;
  right: auto;
  z-index: 999;
  &::after {
    content: "";
    display: block;
    width: 2px;
    height: 90px;
    margin: 0px auto;
    background: grey;
    z-index: 4;
  }

  li {
    margin: 10px;
  }

  .contains-social {
    display: flex;
    flex-direction: column;
    -webkit-box-align: center;
    align-items: center;
    margin: 0px;
    padding: 0px;
    list-style: none;
  }

 

  li:hover {
    background: rgba(0, 0, 0, 0.11);
    border-radius: 5px;
  }

  a {
    text-decoration: none;
    text-decoration-skip-ink: auto;
    color: inherit;
  }

  @media (max-width: 768px) { 
    display: none;
    visibility: hidden;
   
  }
`

export default Social;